import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';

export const initialValuesService = {
  description: '',
  code: '',
  page: 0,
  rowsPerPage: 10,
  orders: {},
};

const PageServicesInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValuesService}>
      <Outlet />
    </FilterTableProvider>
  );
};

PageServicesInitializer.displayName = 'Page services initializer component';

export default PageServicesInitializer;
